export default __webpack_public_path__ + "static/media/mysql.f9e45d29.svg";